import { render, staticRenderFns } from "./SidebarMenuHr.vue?vue&type=template&id=407f5512&"
import script from "./SidebarMenuHr.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuHr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports